var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_c('span',{staticClass:"prompt"},[_vm._v(_vm._s(_vm.command.prompt))]),_c('span',{staticClass:"historyText",class:[_vm.command.error ? 'error' : '']},[_vm._v(_vm._s(_vm.command.text || _vm.command.data))])])}
var staticRenderFns = []

export { render, staticRenderFns }